export const yearOptions = { year: "numeric" };
export const dateOptions = { month: "2-digit", day: "2-digit" };
export const secondsOptions = { second: "2-digit" };
export const time12Options = { hour: "numeric", minute: "2-digit", hourCycle: "h12" };
export const time24Options = { hour: "2-digit", minute: "2-digit", hourCycle: "h23" };
//# sourceMappingURL=dateTimeOptions.js.map